import { render, staticRenderFns } from "./headMenu3.vue?vue&type=template&id=4612c3e2&scoped=true"
import script from "./headMenu3.vue?vue&type=script&lang=js"
export * from "./headMenu3.vue?vue&type=script&lang=js"
import style0 from "./headMenu3.vue?vue&type=style&index=0&id=4612c3e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4612c3e2",
  null
  
)

export default component.exports